export const CREATORS = [
  'riocurara',
  'russet_down',
  'osarusyaaan',
  'monamona_game',
] as const
export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  russet_down: 'overwatch2_1',
  osarusyaaan: 'overwatch2_2',
  riocurara: 'overwatch2_3',
  monamona_game: 'overwatch2_4',
}

export const mapOverwatch2CreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
    creatorImageURL: string
  }
> = {
  riocurara: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['riocurara']}/0.jpeg`,
    creatorImageURL: '/static/images/creators/russet_down.png',
  },
  russet_down: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['russet_down']}/0.jpeg`,
    creatorImageURL: '/static/images/creators/russet_down.png',
  },
  osarusyaaan: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['osarusyaaan']}/0.jpeg`,
    creatorImageURL: '/static/images/creators/osarusyaaan.png',
  },

  monamona_game: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['monamona_game']}/0-min.jpeg`,
    creatorImageURL: `/static/images/profiles/${creatorMapTargetId['monamona_game']}/0-min.jpeg`,
  },
}
